import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted } from 'vue'
import { UIDropdownTree } from '@gohighlevel/ghl-ui'
import { Tag01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { transformMenuOption } from 'common/utils/helper'
import { getTagOptions, getEmailOptions } from 'common/config'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomVariablePicker',
  props: {
  id: { type: String, default: '' },
  class: { type: String, default: '' },
  noMarginTop: {
    type: Boolean,
    default: false,
  },
  outsideField: {
    type: Boolean,
    default: false,
  },
  customFieldsLocation: {
    type: Array as PropType<Array<ICustomField>>,
    default: [],
  },
  customValuesLocation: {
    type: Array as PropType<Array<ICustomValue>>,
    default: [],
  },
  triggerLinks: {
    type: Array as PropType<Array<ITriggerLinks>>,
    default: [],
  },
  emailTagsOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:selectedValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const customValues = ref(transformMenuOption(getTagOptions()))
const emit = __emit
const handleSelect = (value: string) => {
  emit('update:selectedValue', { value })
}
onMounted(() => {
  let options = transformMenuOption(
    props.emailTagsOnly ? getEmailOptions() : getTagOptions()
  )
  if (props.customValuesLocation?.length) {
    options = [
      ...options,
      {
        label: 'Custom Values',
        value: 'Custom Values',
        children: props.customValuesLocation,
      },
    ]
  }
  if (props.customFieldsLocation?.length) {
    const contactIndex = options.findIndex(
      val => val.label.toLowerCase() === 'contact'
    )
    if (contactIndex > -1) {
      options[contactIndex].children = [
        ...options[contactIndex].children,
        {
          label: 'Custom Fields',
          value: 'Custom Fields',
          children: props.customFieldsLocation.map(({ name, fieldKey }) => ({
            label: name,
            value: `{{${fieldKey}}}`,
          })),
        },
      ]
    }
  }

  if (props?.triggerLinks?.length) {
    options = [
      ...options,
      {
        label: 'Trigger Links',
        value: 'Trigger Links',
        children: props.triggerLinks.map(link => ({
          label: link.name,
          value: `{{trigger_link.${link.id}}}`,
        })),
      },
    ]
  }
  customValues.value = options
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(UIDropdownTree), {
      options: customValues.value,
      onOnSelect: handleSelect,
      placement: "bottom-end",
      id: `custom-value-dropdown${__props.id}`
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center cursor-pointer", [
            __props.noMarginTop ? 'mt-0' : 'mt-5',
            __props.outsideField ? 'relative' : 'absolute inset-y-0 right-0 pr-3 pl-2',
          ]])
        }, [
          _createVNode(_unref(Tag01Icon), { class: "h-5 w-5" })
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["options", "id"])
  ]))
}
}

})